import React, { useState, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const BureauContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0b0b0b;
  cursor: pointer;
`;

const BackgroundImage = styled.div<{ $imageUrl: string; $visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${props => props.$imageUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: ${props => (props.$visible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  z-index: 1;
  background-color: #0b0b0b;
`;

const CenteredText = styled.h1`
  font-size: 2.5rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
  font-family: var(--font-primary);
  mix-blend-mode: exclusion;
  color: white;
  pointer-events: none;
  z-index: 2;
  position: relative;
`;

const images = [
  '/images/Sporting%20Lagos%20Identity%20with%20Belonwus_04.jpg',
  '/images/rise%20HQ%20with%20DHK_01.jpg',
  '/images/Pocket%20Set%20Design%20with%20Belonwus_01.jpg',
  '/images/Spotify%20with%20Belonwus_01.jpg',
  '/images/Minies%20Kitchen%20Brand%20Identity_01.jpg',
  '/images/Babban%20Gona%20Identity.jpg',
  '/images/9mobile%20Set%20Design%20with%20Belonwus_01.jpg',
];

const Bureau = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(-1);
  const [loadedIndexes, setLoadedIndexes] = useState<Set<number>>(() => new Set());
  const preloadingRef = useRef<Set<number>>(new Set());
  const navigate = useNavigate();

  const preloadImage = useCallback((index: number) => {
    if (index < 0 || index >= images.length) return;
    if (preloadingRef.current.has(index)) return;

    preloadingRef.current.add(index);
    const img = new Image();
    img.decoding = 'async';
    img.src = images[index];
    img.onload = () => {
      setLoadedIndexes(prev => {
        if (prev.has(index)) return prev;
        const next = new Set(prev);
        next.add(index);
        return next;
      });
    };
    img.onerror = () => {
      preloadingRef.current.delete(index);
    };
  }, []);

  const handleMouseMove = (e: React.MouseEvent) => {
    const containerWidth = window.innerWidth;
    const mouseX = e.clientX;
    const section = Math.min(
      images.length - 1,
      Math.max(0, Math.floor((mouseX / containerWidth) * images.length))
    );

    preloadImage(section);
    // Warm the neighboring sections so the hover feels instant
    preloadImage(section - 1);
    preloadImage(section + 1);
    setCurrentImageIndex(section);
  };

  const handleClick = () => {
    navigate('/portfolio');
  };

  return (
    <BureauContainer
      onMouseMove={handleMouseMove}
      onMouseLeave={() => setCurrentImageIndex(-1)}
      onClick={handleClick}
    >
      {Array.from(loadedIndexes).map(index => (
        <BackgroundImage
          key={images[index]}
          $imageUrl={images[index]}
          $visible={currentImageIndex === index}
        />
      ))}
      <CenteredText>Dare Ogunnaike</CenteredText>
    </BureauContainer>
  );
};

export default Bureau;
